import { useSelector } from 'react-redux';
import * as AgencyService from 'services/sales/agency';

// Sales-side agency reads (earnings, spend, subscriptions, invoices). Distinct
// from the IAM `useAgencyService`, which manages the agency record itself.
export const useAgencySalesService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchStats = async (options = {}) => {
    const { error, payload } = await AgencyService.readStats({ ...options, token });
    if (error) {
      return { stats: null };
    }

    return { stats: payload };
  };

  const fetchActiveSubscriptions = async (options = {}) => {
    const { error, payload } = await AgencyService.readSubscriptions({ ...options, token });
    if (error) {
      return { subscriptions: [] };
    }

    const { data: subscriptions } = payload;
    return { subscriptions: subscriptions || [] };
  };

  const fetchInvoiceSummary = async (options = {}) => {
    const { error, payload } = await AgencyService.readInvoices({ ...options, token });
    if (error) {
      return { paid: [], unpaid: [], meta: {} };
    }

    return payload;
  };

  return { fetchStats, fetchActiveSubscriptions, fetchInvoiceSummary };
};
